<alt-event [showNavbar]="true" [isStaffView]="false"></alt-event>
